export default __webpack_public_path__ + "static/media/ob-logo.9ce64ba6.png";